/* eslint-disable no-dupe-keys */
export default {
  billing_rule_timer: {
    name: '费率定时器',
    // 属性（一般与对象内容匹配）
    prop: {
      service_provider: '运营商',
      charge_station: '充电站',
      synchronize_charge_stations: '同步更新的场站',
      need_confirm: '是否需要确认',
      prcings: '分时费率',
      effective_charge_station: '生效电站',
      effective_time: '生效时间',
      billing_rule: '定时生效的费率',
      current_billing_rule: '站当前费率',
      status: '状态',
      created_at: '创建时间',
      updated_at: '更新时间',
      last_executed_at: '执行时间',
      confirm_status: '确认状态',
      // 非对象属性
      billing_rule_change: '费率调整变化',
      time_change: '时间调整变化',
      confirm_time: '确认时间',
      confirm_admin: '确认人',
      phone_preview: '手机预览'
    },
    // Enum的属性
    // Boolean的属性
    // 占位提示
    // 列表标签
    list_tabs: {
      all: '全部',
      active: '已生效',
      inactive: '待生效'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息'
    },
    // 标题
    titles: {
      base_info: '基本信息',
      station_order_summary: '所选场站最近三个月的数据',
      station_billing_rule: '站原来的费率',
      target_billing_rule: '目标生效的费率',
      select_charge_station: '选择充电站',
      definition_prcings: '定义费率',
      effective_info: '生效条件'
    },
    validates: {
      error_form: '表单填写有误，请检查'
    },
    // 状态
    statuses: {
      active: '已生效',
      inactive: '待生效'
    },
    confirm_statuses: {
      confirmed: '已确认',
      not_confirmed: '待确认'
    },
    need_confirms: {
      true: '需要确认',
      false: '无需确认'
    },
    toast: {
      save_success: '已确认成功,可以继续添加下一个或者直接提交数据'
    },
    btn: {
      clone: '克隆其他充电费率',
      clone_current_rule: '克隆站当前费率',
      preview_billing_rule: '预览费率',
      reload_edit: '重新编辑',
      expand: '展开',
      collapse: '收起'
    },
    tips: {
      effective_time_consuming: '费率切换需要大约30秒的时间，所以建议设置适当提前1分钟以上',
      after_confirm: '保存信息后才能点击新建和新增费率',
      need_confirm: '需要分享给运营商，并且通过确认后才会生效'
    },
    placeholder: {
      need_confirm: '需确认/无需确认',
      confirm_status: '待确认/已确认'
    }
  }
}
